import { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';

import Dochano from './pages/Dochano';
import Home from './pages/Home';
import Resume from './pages/Resume';
import Exploration from './pages/Exploration';
import Learning from './pages/Learning';
import Extension from './pages/Extension';
import Management from './pages/Management';
import Travel from './pages/Travel';
import Retrospectives from './pages/Retrospectives';
import RetroTime from './pages/RetroTime';
import Theme from './pages/Theme';
import Maze from './pages/Maze';
import ErrorBoundary from './components/ErrorBoundary';
import NotFound from './pages/NotFound';
import './styles/App.scss';
import { FaSun, FaMoon } from 'react-icons/fa';
import { ReactComponent as DochanoLogo } from './assets/d_Logo.svg'
import MyChart from './pages/MyChart';

// Create a component that can use the useLocation hook
function MainContent() {
  const [theme, setTheme] = useState('light');
  const [isOpen, setIsOpen] = useState(false);
  const toggleRef = useRef(null);
  const location = useLocation(); // Call the useLocation hook here
  const isResumeActive = location.pathname === '/resume';

  const handleToggle = () => {
    setIsOpen(prev => !prev);
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      setTheme(storedTheme);
    }

    // Close on Escape or outside click
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
        toggleRef.current?.focus();
      }
    };

    const handleClickOutside = (e) => {
      if (
        toggleRef.current &&
        !toggleRef.current.contains(e.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <>
      <nav className="mainNav" aria-label="Main Navigation">
        <ul>
          <li><Link to="/dochano"><DochanoLogo alt="Donchano - Don't you know? logo" width="25" height="25"  /></Link></li>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/resume">Resume</Link></li>
          <li className="hasSubNav">
            <button className="navToggle" ref={toggleRef} aria-haspopup="true" aria-expanded="false" aria-controls="products-subnav" id="LinkExpansion" onClick={handleToggle} title={isOpen ? 'Close Additional Navigation' : 'Additional Navigation'}>
              <div className={isOpen ? 'hamburger open' : 'hamburger'}><span></span><span></span><span></span></div></button>
            <ul className={"subnav " + theme} id="products-subnav" role="menu" aria-labelledby="products-toggle" style={{ display: isOpen ? 'block' : 'none' }}>
              <li><Link to="/learning">Learning</Link></li>
              <li><Link to="/extension">Job Post Extractor</Link></li>
              <li><Link to="/mychart">MyChart Lab Director</Link></li>
              <li><Link to="/retrospectives">Retrospectives</Link></li>
              <li><Link to="/travel">World Map</Link></li>
              <li><Link to="/exploration">Exploration</Link></li>
              <li><Link to="/management">Management</Link></li>
            </ul>
          </li>
        </ul>
      </nav>

      <div id="main" className={(isResumeActive) ? "noTheme" : theme + "-mode"}>
        {(!isResumeActive) && <button id="mode-toggle-button" onClick={toggleTheme}>{theme === 'light' ? "Dark Mode" : "Light Mode"}: <span>{theme === 'light' ? <FaMoon title="Moon" /> : <FaSun title="Sun" />}</span></button>}
        {/*-}<FaWix className="white" />{-*/}
        <Routes>
          <Route path="/dochano" element={<Dochano />} />
          <Route path="/" element={<Home />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/exploration" element={<Exploration />} />
          <Route path="/learning" element={<Learning />} />
          <Route path="/extension" element={<Extension />} />
          <Route path="/management" element={<Management />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/retrotime" element={<RetroTime />} />
          <Route path="/retrospectives" element={<Retrospectives />} />
          <Route path="/theme/:slug" element={<Theme />} />
          <Route path="/maze" element={<Maze />} />
          <Route path="/mychart" element={<MyChart />} />
          {/* The wildcard "*" matches any URL not defined above */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </>
  );
}

// The App component only contains the Router and ErrorBoundary
function App() {
  return (
    <ErrorBoundary>
      <Router>
        <MainContent />
      </Router>
    </ErrorBoundary>
  );
}

export default App;